var exports = {
  "DD": "xdbfd91f1--dfdc34--title",
  "Ve": "xdbfd91f1--dfdc34--info_item",
  "gZ": "xdbfd91f1--dfdc34--info_title",
};

module.exports = exports;
